import { useState } from 'react';
import { LOADING_STATES, LoadingState } from '../constants/fillyConstants';

export const useLoadingState = () => {
  const [currentLoadingState, setCurrentLoadingState] = useState<LoadingState>(null);

  const setLoading = (state: LoadingState) => {
    setCurrentLoadingState(state);
  };

  const clearLoading = () => {
    setCurrentLoadingState(null);
  };

  const isLoading = currentLoadingState !== null;

  const getLoadingMessage = (): string => {
    if (!currentLoadingState) return '';
    return LOADING_STATES[currentLoadingState];
  };

  return {
    currentLoadingState,
    setLoading,
    clearLoading,
    isLoading,
    getLoadingMessage
  };
};

export default useLoadingState;
